import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetChargePointsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/inputs/get-charge-points-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterChargePointListContext } from '../../charge-point.context';
import { ChargePointListFilterFormStep1Controller } from '../charge-point-list-filter-form-step-1/charge-point-list-filter-form-step-1.controller';

export interface ChargePointListFilterFormControllerProps {
  onError: SubmitErrorHandler<GetChargePointsPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetChargePointsPaginatedModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const ChargePointListFilterFormController = (
  props: ChargePointListFilterFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useFilterChargePointListContext();

  return (
    <MultiStepFormProvider<GetChargePointsPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: [
            'isOnline',
            'isMaintenance',
            'customerId',
            'hasTariff',
            'hasLocation',
            'hasSubscription',
            'lastMessageReceivedDate',
            'locationId',
            'networkId',
            'tariffId',
          ],
          component: <ChargePointListFilterFormStep1Controller />,
        },
      ]}
    />
  );
};
